import { chartSchema } from '../schemas';
import {
  chartReducer,
  CHANGE_CART_LOADING_TYPE,
  CHART_ACTIVATE_BREAKDOWN_MODE,
  CHART_DEACTIVATE_BREAKDOWN_MODE,
  SHOW_CHART_ANNOTATIONS,
  HIDE_CHART_ANNOTATIONS,
  SET_CHART_BREAKDOWN,
  SET_CHART_METRICS,
  SET_CHART_SETTINGS,
  SET_CHART_VIEW_SETTINGS,
  SET_CHART_WIDTH,
} from './chartReducer';

export const REMOVE_CHART = 'REMOVE_CHART';
export const ADD_CHART = 'ADD_CHART';
export const DUPLICATE_CHART = 'DUPLICATE_CHART';
export const SET_CHARTS_WIDTHS = 'SET_CHARTS_WIDTHS';
export const SET_CHARTS_LOADING_TYPE = 'SET_CHARTS_LOADING_TYPE';
export const SET_CHARTS_DEACTIVATE_BREAKDOWN_MODE =
  'SET_CHARTS_DEACTIVATE_BREAKDOWN_MODE';

export {
  CHANGE_CART_LOADING_TYPE,
  CHART_ACTIVATE_BREAKDOWN_MODE,
  CHART_DEACTIVATE_BREAKDOWN_MODE,
  SHOW_CHART_ANNOTATIONS,
  HIDE_CHART_ANNOTATIONS,
  SET_CHART_BREAKDOWN,
  SET_CHART_METRICS,
  SET_CHART_SETTINGS,
  SET_CHART_VIEW_SETTINGS,
  SET_CHART_WIDTH,
};

function getChartWidth(charts) {
  return Number((100 / charts.length).toFixed(2));
}

export function chartsReducer(state, action) {
  switch (action.type) {
    case REMOVE_CHART: {
      const { index } = action.payload;
      const newCharts = [...state.slice(0, index), ...state.slice(index + 1)];
      const newWidth = getChartWidth(newCharts);
      return newCharts.map((chart) => ({
        ...chart,
        width: newWidth,
      }));
    }
    case ADD_CHART: {
      const newCharts = [...state, chartSchema.default()];
      const newWidth = getChartWidth(newCharts);

      return newCharts.map((chart) => ({
        ...chart,
        width: newWidth,
      }));
    }

    case DUPLICATE_CHART: {
      const { index } = action.payload;
      const newCharts = [...state, state[index]];
      const newWidth = getChartWidth(newCharts);

      return newCharts.map((chart) => ({
        ...chart,
        width: newWidth,
      }));
    }
    case SET_CHARTS_WIDTHS: {
      return state.map((chart, index) =>
        chartReducer(chart, {
          type: SET_CHART_WIDTH,
          payload: action.payload[index],
        })
      );
    }

    case SET_CHARTS_LOADING_TYPE:
      return state.map((chart) =>
        chartReducer(chart, {
          type: CHANGE_CART_LOADING_TYPE,
          payload: action.payload,
        })
      );

    case SET_CHARTS_DEACTIVATE_BREAKDOWN_MODE:
      return state.map((chart) =>
        chartReducer(chart, {
          type: CHART_DEACTIVATE_BREAKDOWN_MODE,
        })
      );
    case CHART_DEACTIVATE_BREAKDOWN_MODE:
    case CHART_ACTIVATE_BREAKDOWN_MODE:
    case SHOW_CHART_ANNOTATIONS:
    case HIDE_CHART_ANNOTATIONS:
    case SET_CHART_BREAKDOWN:
    case SET_CHART_METRICS:
    case SET_CHART_SETTINGS:
    case SET_CHART_VIEW_SETTINGS: {
      const { index, value } = action.payload;

      return state.map((c, i) => {
        if (i === index) {
          return chartReducer(state[index], {
            type: action.type,
            payload: value,
          });
        }
        return c;
      });
    }

    default:
      return state;
  }
}
